var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M1.098 0 9.15 7.515a1.247 1.247 0 0 0 1.7 0L18.902 0zM0 .93v10.917L5.647 6.2zm20 0L14.353 6.2 20 11.847zM6.69 7.174l-5.68 5.682h17.98l-5.682-5.682-1.483 1.384a2.67 2.67 0 0 1-1.826.717c-.657 0-1.313-.24-1.825-.717z"
  })));
};
export default SvgMail;